<template>
  <FriedTableCell>
    <div v-if="sortedTags.length > 0" class="table-resource-tags">
      <Tag
        :show-active-state="false"
        :class="['first-tag', { clickable }]"
        truncate
        :disabled="!clickable"
        :external-id="`library-table-${resourceId}-tags-${sortedTags[0]}`"
        @click="clickable && $emit('tag-clicked')"
      >
        {{ sortedTags[0] }}
      </Tag>
      <FriedDropdown :main-axis-offset="8" placement="bottom-end" :close-on-action="false">
        <template #trigger>
          <FriedStatusBadge
            v-if="sortedTags.length > 1"
            class="status-badge"
            :text="`+${sortedTags.length - 1}`"
            :enable-min-width="false"
          />
        </template>
        <template #content>
          <FriedH5>{{ $t('tags') }} ({{ sortedTags.length }})</FriedH5>
          <div class="tags">
            <Tag
              v-for="tag in sortedTags"
              :key="tag"
              class="content-tag"
              truncate
              disabled
              :show-active-state="false"
              :external-id="`library-table-${resourceId}-tags-${tag}`"
            >
              {{ tag }}
            </Tag>
          </div>
        </template>
      </FriedDropdown>
    </div>
  </FriedTableCell>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import type { ContentTagCategory } from '../types';
import Tag from './Tag.vue';

const {
  categories,
  resourceId,
  tags,
  clickable = false,
} = defineProps<{
  categories: ContentTagCategory[];
  resourceId: string;
  tags: string[];
  clickable?: boolean;
}>();

defineEmits<{ 'tag-clicked': [] }>();

const getTagName = (tagId: string) => {
  const tag = categories?.flatMap(category => category.tags).find(tag => tag?.id === tagId);
  return tag ? tag.name : '';
};

const sortedTags = computed(() => {
  if (!tags) {
    return [];
  }
  return tags
    .map(tagId => getTagName(tagId))
    .filter(tagName => !!tagName)
    .sort((a: string, b: string) => a.trim().localeCompare(b.trim()));
});
</script>
<style lang="scss" scoped>
.table-resource-tags,
.tags {
  display: flex;
  align-items: center;
  gap: var(--spacing-50);

  .heading-5 {
    margin-bottom: var(--spacing-50);
  }

  .status-badge {
    cursor: pointer;

    &:not(.color) {
      background: var(--gray-96);
    }
  }
}

.first-tag {
  cursor: default;

  &.clickable {
    cursor: pointer;
  }
}

.tags {
  flex-wrap: wrap;
  max-width: 250px;

  .content-tag {
    cursor: default;
  }
}
</style>
